const base = "https://final.hr2538.workers.dev"

const routes = {
    traffic_change: base + "/traffic-change",
    popular_domains: base + "/popular-domains",
    attack_layer: base + "/attack-layer3"
}

export default routes;